/* Wishlist.

   WHERE IT IS KEPT: localStorage, under a key of the signed-in customer's own
   (gs-wishlist:<id>) so two people sharing a machine do not see each other's
   list. A list that follows a customer between devices has to live on the
   customer record, which on Shopify means an app; this is the version that
   needs no app.

   TO PUT A HEART ON A CARD, add:
     <button class="gs-heart" data-gs-wish="<product handle>"></button>
   This file draws the icon, keeps the state and handles the click. Clicks are
   delegated, so cards rendered later by JavaScript work with no extra wiring.

   Cards this file does not own — the products grid, the search results — get a
   heart adopted onto them instead: any list item in those grids that links to
   a product has one pinned to its corner. A MutationObserver re-runs that pass
   whenever those grids re-render, which they do constantly. */

(function () {
  'use strict';

  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.4 2.7 12.1V7.3L7 3h3.1L12 5.5 13.9 3H17l4.3 4.3v4.8z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  var ADOPT = 'li.gs-prod, [data-gs-rgrid] > li, .gs-results__grid > li, .gs-hub li';

  var KEY = 'gs-wishlist';
  try {
    var node = document.getElementById('gs-ann-state');
    if (node) {
      var st = JSON.parse(node.textContent);
      if (st && st.customerId) KEY = 'gs-wishlist:' + st.customerId;
    }
  } catch (err) { /* anonymous list */ }

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (err) {
      return [];
    }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (err) { /* private mode */ }
  }

  var saved = read();

  function has(h) { return saved.indexOf(h) > -1; }

  function toggle(h) {
    var i = saved.indexOf(h);
    if (i > -1) saved.splice(i, 1);
    else saved.unshift(h);
    write(saved);
    sync();
    return i === -1;
  }

  /* ---------------------------------------------------------- the hearts */

  function dress(btn) {
    if (!btn.firstChild) btn.innerHTML = ICON;
    var on = has(btn.dataset.gsWish);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var path = btn.querySelector('path');
    if (path) path.setAttribute('fill', on ? 'currentColor' : 'none');
  }

  function sync() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gs-wish]'), dress);
    var badge = document.querySelector('[data-gs-wishcount]');
    if (badge) {
      badge.textContent = saved.length;
      badge.hidden = saved.length === 0;
    }
  }

  function adopt() {
    Array.prototype.forEach.call(document.querySelectorAll(ADOPT), function (li) {
      if (li.querySelector('[data-gs-wish]')) return;
      var link = li.querySelector('a[href*="/products/"]');
      if (!link) return;

      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;

      if (window.getComputedStyle(li).position === 'static') li.style.position = 'relative';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gs-heart gs-heart--pin';
      btn.dataset.gsWish = m[1];
      btn.setAttribute('aria-label', 'Save to your wishlist');
      li.appendChild(btn);
      dress(btn);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-gs-wish]') : null;
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var added = toggle(btn.dataset.gsWish);
    if (added) {
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
    }
    if (btn.closest('[data-gs-wishlist-page]') && !added) render();
  });

  /* --------------------------------------------------- the header button */

  function mountHeader() {
    if (document.querySelector('.gs-wishbtn')) return true;

    /* Horizon's cart is a <cart-icon> custom element, not a link, so anchor on
       that and fall back to whatever account or cart link exists. */
    var anchor = document.querySelector('cart-icon');
    if (anchor && anchor.closest) anchor = anchor.closest('a, button, .header-actions__action') || anchor;
    if (!anchor) anchor = document.querySelector('a[href*="/cart"], a[href*="/account"]');
    if (!anchor || !anchor.parentElement) return false;

    var a = document.createElement('a');
    a.className = 'gs-wishbtn header-actions__action';
    a.href = '/pages/wishlist';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = ICON + '<span class="gs-wishbtn__count" data-gs-wishcount hidden>0</span>';
    anchor.parentElement.insertBefore(a, anchor);
    return true;
  }

  /* ------------------------------------------------------ wishlist page */

  var page = document.querySelector('[data-gs-wishlist-page]');

  function money(cents) { return 'Dhs. ' + (cents / 100).toFixed(2); }

  function card(p) {
    var v = p.variants && p.variants[0];
    var off = 0;
    if (v && v.compare_at_price && v.compare_at_price > v.price) {
      off = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
    }

    var img = p.featured_image || (p.images && p.images[0]) || '';
    var price = v ? money(v.price) : '';
    if (off) price = '<s>' + money(v.compare_at_price) + '</s>' + price;

    return (
      '<li class="gs-wish__item">' +
      '<a class="gs-wish__card" href="/products/' + p.handle + '">' +
      '<span class="gs-wish__media">' +
      (off ? '<span class="gs-sale">' + off + '% off</span>' : '') +
      (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
      '</span><span class="gs-wish__body">' +
      '<span class="gs-wish__title">' + p.title + '</span>' +
      '<span class="gs-wish__price">' + price + '</span>' +
      '</span></a>' +
      '<button type="button" class="gs-heart" data-gs-wish="' + p.handle + '" aria-label="Remove from wishlist"></button>' +
      '</li>'
    );
  }

  function render() {
    if (!page) return;
    var grid = page.querySelector('[data-gs-wishgrid]');
    var empty = page.querySelector('[data-gs-wishempty]');
    if (!grid) return;

    if (!saved.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    Promise.all(
      saved.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (list) {
      var rows = list.filter(Boolean).map(card).join('');
      grid.innerHTML = rows;
      if (!rows && empty) empty.hidden = false;
      sync();
    });
  }

  /* ---------------------------------------------------------------- boot */

  if (!mountHeader()) window.setTimeout(mountHeader, 500);
  window.setTimeout(function () { mountHeader(); adopt(); sync(); }, 1500);

  var pending = null;
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(function () { adopt(); sync(); }, 160);
    }).observe(document.body, { childList: true, subtree: true });
  }

  adopt();
  sync();
  render();
})();
